/* eslint-disable multiline-ternary */
import React, { useContext } from 'react'
import { Grid } from '@material-ui/core'
import { isEmpty } from 'lodash'
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles'

import MainTemplate from '../../templates/MainTemplate'
import Filters from '../../containers/orders/detailedPharmacy/filters/Details'

import PharmaciesOrdersFinished from '../../containers/orders/detailedPharmacy/widgets/PharmaciesOrdersFinished'
import PharmaciesOrdersCancelled from '../../containers/orders/detailedPharmacy/widgets/PharmaciesOrdersCancelled'
import FinishedOrders from '../../containers/orders/detailedPharmacy/widgets/FinishedOrders'
import NotFinishedOrders from '../../containers/orders/detailedPharmacy/widgets/NotFinishedOrders'
// import TotalViewsOffers from '../../containers/orders/detailedPharmacy/widgets/TotalViewsOffers'

import LastUpdatedOffer from '../../containers/orders/detailedPharmacy/widgets/SinglePharmacySelected/LastUpdatedOffer'
import MinimumOrder from '../../containers/orders/detailedPharmacy/widgets/SinglePharmacySelected/MinimumOrder'
import QuantityOffers from '../../containers/orders/detailedPharmacy/widgets/SinglePharmacySelected/QuantityOffers'
import OpenAfter from '../../containers/orders/detailedPharmacy/widgets/SinglePharmacySelected/OpenAfter'
import OpenAllDay from '../../containers/orders/detailedPharmacy/widgets/SinglePharmacySelected/OpenAllDay'
import DeliveryOn from '../../containers/orders/detailedPharmacy/widgets/SinglePharmacySelected/DeliveryOn'
import PaymentReceivedOn from '../../containers/orders/detailedPharmacy/widgets/SinglePharmacySelected/PaymentReceivedOn'
import PaymentValidityEnd from '../../containers/orders/detailedPharmacy/widgets/SinglePharmacySelected/PaymentValidityEnd'
import PercentTakeRate from '../../containers/orders/detailedPharmacy/widgets/SinglePharmacySelected/PercentTakeRate'

import PaymentsMethod from '../../containers/orders/detailedPharmacy/chart/PaymentsMethod'
import MoreOrdersProducts from '../../containers/orders/detailedPharmacy/chart/MoreOrdersProducts'
// import PaymentsMethodCard from '../../containers/orders/detailedPharmacy/chart/PaymentsMethodCard'
// import CategoryMostSell from '../../containers/orders/detailedPharmacy/chart/CategoryMostSell'
import DailyOrderTotals from '../../containers/orders/detailedPharmacy/chart/DailyOrderTotals'
import CancelledReason from '../../containers/orders/detailedPharmacy/chart/CancelledReason'
import { PharmaciesDetailsFiltersContext } from '../../context/PharmaciesDetailsFiltersContext'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      marginTop: theme.spacing(2)
    }
  })
)

const DetailedPharmacy = (): JSX.Element => {
  const classes = useStyles()
  const { filters } = useContext(PharmaciesDetailsFiltersContext)
  const [singlePharmacyFiltered, setSinglePharmacyFiltered] =
    React.useState(false)

  React.useEffect(() => {
    const pharmaciesLenght = filters.pharmacies?.length

    if (pharmaciesLenght === 1) {
      setSinglePharmacyFiltered(true)
    } else {
      setSinglePharmacyFiltered(false)
    }
  }, [filters])

  return (
    <MainTemplate>
      <Filters />
      {isEmpty(filters.pharmacies) ? (
        <>
          <h3>Selecione uma farmácia</h3>
        </>
      ) : (
        <>
          {' '}
          <Grid item container spacing={1} className={classes.container}>
            <Grid item sm={12} md={6} xs={12}>
              <PharmaciesOrdersFinished />
            </Grid>
            <Grid item sm={12} md={6} xs={12}>
              <PharmaciesOrdersCancelled />
            </Grid>
            {/* <Grid item sm={12} md={4} xs={12}>
              <TotalViewsOffers />
            </Grid> */}
          </Grid>
          <Grid item container spacing={1} className={classes.container}>
            <Grid item sm={12} md={6} xs={12}>
              <FinishedOrders />
            </Grid>
            <Grid item sm={12} md={6} xs={12}>
              <NotFinishedOrders />
            </Grid>
          </Grid>
          {/* SHOW ONLY SINGLE PHARMACY SELECTED */}
          {singlePharmacyFiltered ? (
            <>
              <Grid item container spacing={1} className={classes.container}>
                <Grid item sm={12} md={6} xs={12}>
                  <MinimumOrder />
                </Grid>
                <Grid item sm={12} md={6} xs={12}>
                  <LastUpdatedOffer />
                </Grid>
              </Grid>
              <Grid item container spacing={1} className={classes.container}>
                <Grid item sm={12} md={4} xs={12}>
                  <QuantityOffers />
                </Grid>
                <Grid item sm={12} md={4} xs={12}>
                  <PaymentValidityEnd />
                </Grid>
                <Grid item sm={12} md={4} xs={12}>
                  <PercentTakeRate />
                </Grid>
              </Grid>
              <Grid item container spacing={1} className={classes.container}>
                <Grid item sm={12} md={3} xs={12}>
                  <PaymentReceivedOn />
                </Grid>
                <Grid item sm={12} md={3} xs={12}>
                  <OpenAfter />
                </Grid>
                <Grid item sm={12} md={3} xs={12}>
                  <OpenAllDay />
                </Grid>
                <Grid item sm={12} md={3} xs={12}>
                  <DeliveryOn />
                </Grid>
              </Grid>
            </>
          ) : (
            ''
          )}
          <Grid item container spacing={1} className={classes.container}>
            <Grid item sm={12} md={12} xs={12}>
              <DailyOrderTotals />
            </Grid>
          </Grid>
          <Grid item container spacing={1} className={classes.container}>
            <Grid item sm={12} md={12} xs={12}>
              <MoreOrdersProducts />
            </Grid>
          </Grid>
          {/* <Grid item container spacing={1} className={classes.container}>
            <Grid item sm={12} md={6} xs={12}>
              <CategoryMostSell />
            </Grid>
            <Grid item sm={12} md={6} xs={12}>
              <MoreOrdersProducts />
            </Grid>
          </Grid> */}
          <Grid item container spacing={1} className={classes.container}>
            <Grid item sm={12} md={6} xs={12}>
              <PaymentsMethod />
            </Grid>
            <Grid item sm={12} md={6} xs={12}>
              <CancelledReason />
            </Grid>
          </Grid>
          {/* <Grid item container spacing={1} className={classes.container}>
            <Grid item sm={12} md={6} xs={12}>
              <PaymentsMethodCard />
            </Grid>
          </Grid> */}
        </>
      )}
    </MainTemplate>
  )
}

export default DetailedPharmacy
